import type { FC } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { StopCardWrapper, type StopCardProps } from "@components";
import { useTranslation } from "react-i18next";
import { getRouteItemId } from "../../helpers/routeMappers";

export const SortableStopCard: FC<StopCardProps> = ({
  stop,
  onMoveToRoute,
  onMoveToAvailable,
  isInvalid,
  routeStops,
}) => {
  const { t } = useTranslation();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: getRouteItemId(stop),
    data: {
      id: getRouteItemId(stop),
      isAvailable: stop.isAvailable,
      orderId: stop.orderId,
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div className="relative flex items-center gap-2 w-full group">
      <div
        ref={setNodeRef}
        style={style}
        {...listeners}
        {...attributes}
        className="flex-1"
      >
        <StopCardWrapper
          stop={stop}
          isDragging={isDragging}
          onMoveToRoute={onMoveToRoute}
          onMoveToAvailable={onMoveToAvailable}
          isInvalid={isInvalid}
          routeStops={routeStops}
          onRemoveItem={!stop.isAvailable ? onMoveToAvailable : undefined}
          isAssignedCard={!stop.isAvailable}
          onAddItem={stop.isAvailable ? onMoveToRoute : undefined}
        />
      </div>
    </div>
  );
};
